import { chunk, get, kebabCase } from 'lodash';
import React from 'react';
import SimpleTable from '../Tables/SimpleTable';

import municipalSearchPlaces from '../../../content/onBuild/municipalSearchPlaces.json';

const CityZipcodeTable = ({ city, state }) => {
  const zipcodes = get(municipalSearchPlaces.find((item) => item.state.toLowerCase() === state.toLowerCase() && kebabCase(item.city) === kebabCase(city)), 'zipcodes', []);
  return zipcodes.length > 1
    ? (
      <SimpleTable>
        <tr>
          <th colSpan="4">Zipcodes Served</th>
        </tr>
        {Array.prototype.map.call(chunk(zipcodes, 4), zipcodeRow => (
          <tr>
            {Array.prototype.map.call(zipcodeRow, zipcode => <td>{zipcode}</td>)}
          </tr>
        ))}
      </SimpleTable>
    )
    : null;
}
export default CityZipcodeTable;
